"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.formatBillions = exports.formatMillions = exports.formatPercent = exports.formatDecimal = exports.formatInteger = void 0;
/**
 * Format a number as an integer, rounding to the closest integer if necessary.
 *
 * @example
 * formatInteger(1.9)   // "2"
 * formatInteger(1.1)   // "1"
 * formatInteger(15999) // "15,999"
 *
 * @param value Number to format
 * @returns Formatted number (as string)
 */
function formatInteger(value) {
    return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
}
exports.formatInteger = formatInteger;
function formatDecimal(value, placesOrOptions) {
    if (placesOrOptions === void 0) { placesOrOptions = 2; }
    return new Intl.NumberFormat(undefined, getOptionsFromPlacesOrOptions(placesOrOptions)).format(value);
}
exports.formatDecimal = formatDecimal;
function formatPercent(value, placesOrOptions) {
    if (placesOrOptions === void 0) { placesOrOptions = 0; }
    return new Intl.NumberFormat(undefined, getOptionsFromPlacesOrOptions(placesOrOptions, "percent")).format(value);
}
exports.formatPercent = formatPercent;
function formatMillions(value, placesOrOptions) {
    if (placesOrOptions === void 0) { placesOrOptions = 2; }
    var millifiedValue = value / 1000000;
    return new Intl.NumberFormat(undefined, getOptionsFromPlacesOrOptions(placesOrOptions)).format(millifiedValue);
}
exports.formatMillions = formatMillions;
function formatBillions(value, placesOrOptions) {
    if (placesOrOptions === void 0) { placesOrOptions = 2; }
    var billifiedValue = value / 1000000000;
    return new Intl.NumberFormat(undefined, getOptionsFromPlacesOrOptions(placesOrOptions)).format(billifiedValue);
}
exports.formatBillions = formatBillions;
/* Helper function to get NumberFormatOptions from utils params */
function getOptionsFromPlacesOrOptions(placesOrOptions, formattingStyle) {
    var formattingStyleForOptions = formattingStyle
        ? { style: formattingStyle }
        : {};
    return typeof placesOrOptions === "number"
        ? __assign({ maximumFractionDigits: placesOrOptions }, formattingStyleForOptions) : __assign(__assign({}, placesOrOptions), formattingStyleForOptions);
}
